import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import { EmptyStatePlaceholderIcon } from './empty-state-placeholder-icon';

const StyledBox = styled(Box)({
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
});

const emptyStatePlaceholderIconStyles = {
    height: {
        xs: '60px',
        sm: '90px',
        xl: '190px',
    },
    width: '300px',
};

const DataGridNoRecords = props => {
    const { messageLine1, messageLine2, actionText, actionHandler } = props;

    return (
        <StyledBox className="data-grid-no-records" data-testid="data-grid-no-records">
            <Stack spacing={2} direction="column" justifyContent="center" alignItems="center" gap={2}>
                <Stack className="data-grid-no-records__messages" direction="column" mt="7%">
                    {messageLine1 && (
                        <Stack direction="row" justifyContent="center">
                            <Typography color="text.textSecondary" variant="body2">
                                {messageLine1}
                            </Typography>
                        </Stack>
                    )}
                    {messageLine2 && (
                        <Stack direction="row" justifyContent="center">
                            <Typography color="text.textSecondary" variant="body2">
                                {messageLine2}
                            </Typography>
                        </Stack>
                    )}
                </Stack>
                <EmptyStatePlaceholderIcon
                    sx={emptyStatePlaceholderIconStyles}
                    data-testid="empty-state-placeholder-icon"
                />
                {actionHandler && (
                    <Button variant="contained" color="primary" onClick={actionHandler}>
                        {actionText}
                    </Button>
                )}
            </Stack>
        </StyledBox>
    );
};

export { DataGridNoRecords };
